import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translate } from 'parking-react-common'
import { get } from 'lodash'

import { forms, ui } from '../redux'

import Panel from '../components/Panel'
import EmailPasswordConfirmationForm from '../components/EmailPasswordConfirmationForm'

const EmailPasswordConfirmationContainer = ({ isLoading, t, uid, code }) => (
    <div>
        <Panel
            title={ t('Set a New Password') }
            border={ ui.INTENT.primary }
            isLoading={ isLoading }
        >
            <EmailPasswordConfirmationForm initialValues={ { uid, code } } />
        </Panel>
    </div>
)

EmailPasswordConfirmationContainer.propTypes = {
    isLoading : PropTypes.bool.isRequired,
    uid       : PropTypes.string.isRequired,
    code      : PropTypes.string.isRequired
}

function mapStateToProps(state, ownProps) {
    return {
        isLoading : forms.isSubmitting(forms.emailLogin.id)(state),
        uid       : get(ownProps, 'match.params.uid'),
        code      : get(ownProps, 'match.params.code')
    }
}

export default translate()(connect(mapStateToProps)(EmailPasswordConfirmationContainer))
